import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: () => import('../views/Home/pdf.vue')
  },
  {
    path: '/PDFN',
    name: 'PDFN',
    component: () => import('../views/Home/PDFN.vue')
  },
  {
    path: '/Sign',
    name: '签到',
    component: () => import('../views/Sign/index.vue')
  },
  {
    path: '/Live',
    name: '直播',
    component: () => import('../views/Live/index.vue')
  },
  {
    path: '/RebroadcastList',
    name: '重播列表',
    component: () => import('../views/RebroadcastList/index.vue')
  },
  {
    path: '/dakaShuo',
    name: '大咖说',
    component: () => import('../views/dakaShuo/index.vue')
  },
  {
    path: '/Vedio',
    name: '重播回看',
    component: () => import('../views/playBack/vedio.vue')
  },
  {
    path: '/playvedio',
    name: '视频播放',
    component: () => import('../views/playBack/playvedio.vue')
  },
  {
    path: '/jinengVedio',
    name: '技能视频',
    component: () => import('../views/jinengVedio/index.vue')
  },
  {
    path: '/jizhenkeVedio',
    name: '急诊科故事',
    component: () => import('../views/jizhenkeVedio/index.vue')
  },
  {
    path: '/jizhenkePlay',
    name: '急诊科视频播放',
    component: () => import('../views/jizhenkeVedio/playVideo.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
